import { defaultLocale, type Locale } from '../../i18n/locales';

const fallbackLocaleOrder: Locale[] = [defaultLocale, 'fi', 'sv', 'en'].filter(
  (loc, idx, arr) => arr.indexOf(loc) === idx,
) as Locale[];

export const pickLocaleString = (value: Record<string, string> | string | undefined, locale: Locale) => {
  if (!value) return '';
  if (typeof value === 'string') return value;
  return (
    value[locale] ??
    fallbackLocaleOrder.map((loc) => value[loc]).find((candidate) => candidate !== undefined) ??
    Object.values(value)[0] ??
    ''
  );
};


export const pickLocaleText = pickLocaleString;

export const resolveHref = (locale: Locale, href: string) => {
  const path = href.startsWith('/') ? href : `/${href}`;
  if (locale === defaultLocale) return path;
  return `/${locale}${path}`;
};
